export default (odds: number, decimalRounding: number) => {
  if (odds < 2) {
    return (1 / (1 - odds)).toFixed(decimalRounding);
  } else if (odds > 2) {
    return (odds - 1).toFixed(decimalRounding);
  }
  return "1.00";
};
